import dayjs from 'dayjs'

export const formatDateTime = (date: string | null | undefined) => {
  let dateAux = date ? dayjs(date) : null
  if (dateAux && !dateAux.isValid()) {
    dateAux = dayjs(date, 'DD-MM-YYYY HH:mm')
  }
  return dateAux && dateAux.isValid() ? dateAux.format('DD-MM-YYYY HH:mm') : null
}

export const formatDate = (date: string | null | undefined) => {
  let dateAux = date ? dayjs(date) : null
  if (dateAux && !dateAux.isValid()) {
    dateAux = dayjs(date, 'DD-MM-YYYY')
  }
  return dateAux && dateAux.isValid() ? dateAux.format('DD-MM-YYYY') : null
}
